import { __require as requireDefineProperties } from '../define-properties/index.js';
import { __require as requireCallBind } from '../call-bind/index.js';
import { __require as requireImplementation } from './implementation.js';
import { __require as requirePolyfill } from './polyfill.js';
import { __require as requireShim } from './shim.js';

var objectIs;
var hasRequiredObjectIs;

function requireObjectIs () {
	if (hasRequiredObjectIs) return objectIs;
	hasRequiredObjectIs = 1;

	var define = requireDefineProperties();
	var callBind = requireCallBind();

	var implementation = requireImplementation();
	var getPolyfill = requirePolyfill();
	var shim = requireShim();

	var polyfill = callBind(getPolyfill(), Object);

	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});

	objectIs = polyfill;
	return objectIs;
}

export { requireObjectIs as __require };
